import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0f956500&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=0f956500&prod&scoped=true&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=0f956500&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f956500",
  null
  
)

export default component.exports